module.exports = __webpack_public_path__ + "static/media/144.95f81745.jpg";